import { environment } from '@env/environment';
import { BaseModel } from './base.model';

export const ALLOWED_DOCUMENT_MIME_TYPES = new Set([
  'image/jpeg', 'image/png',
  'application/pdf',
]);

export class FileModel extends BaseModel {
  id!: number;
  instanceId?: number;
  imageId?: number;
  originalName?: string;
  mimeType?: string;
  storageType?: string;
  storageKey?: string;
  size?: number;
  url?: string;
  purpose?: string;
  createdAt?: string;
  updatedAt?: string;

  get downloadUrl(): string {
    if (!this.id) {
      return '';
    }
    return `${environment.apiBaseUrl}/files/${this.id}`;
  }
}
